import {Component, OnInit, ViewChild} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {environment} from '../../../environments/environment';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';
import {AlarmService} from '../../shared/services/alarm/alarm.service';
import {ActivatedRoute} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {ReferentialService} from '../../shared/services/referential/referential.service';
import {TranslateService} from '@ngx-translate/core';
import {ModalService} from '../../shared/services/modal/modal.service';
import {StatesService} from '../../shared/services/state/states.service';
import {ProjectAlarmsCrudComponent} from '../project/project-alarms-crud/project-alarms-crud.component';
import {map} from 'rxjs/internal/operators';
import {Subscription} from 'rxjs';
import {AlarmsTypes} from '../../shared/types/alarms.types';
import ValidableAlarm = AlarmsTypes.ValidableAlarm;
import {AlarmsConstants} from '../../shared/constants/alarms.constants';
import STATUS = AlarmsConstants.STATUS;

export const MAT_TABLE_COLUMN: string[] = ['id', 'status', 'projectName', 'type', 'parentAlarmName', 'name'];

@Component({
  selector: 'app-projects-alarms-validator',
  templateUrl: './projects-alarms-validator.component.html',
  styleUrls: ['./projects-alarms-validator.component.css']
})
export class ProjectsAlarmsValidatorComponent implements OnInit {

  public validableAlarmsList: MatTableDataSource<ValidableAlarm>;
  public displayedColumns: string[];
  public showSpinner: boolean;
  public pageSizeOptions: number[] = environment.pageSizeOptions;
  public pageSize: number = environment.pageSize;
  readonly defaultDisplayedColumn = MAT_TABLE_COLUMN;
  readonly STATUS = STATUS;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(private alarmService: AlarmService,
              private route: ActivatedRoute,
              private toastr: ToastrService,
              private referentialService: ReferentialService,
              private translate: TranslateService,
              private modalService: ModalService,
              public statesService: StatesService) {
  }

  ngOnInit() {
    this.getValidableAlarms();
  }

  openModal(mode: string, alarmId: number = null): void {
    const modalRef = this.modalService.openNgbModal(ProjectAlarmsCrudComponent, {size: 'lg'});
    modalRef.componentInstance.projectId = parseInt(this.route.snapshot.paramMap.get('idProject'), 10);
    modalRef.componentInstance.readOnly = mode === 'read';
    modalRef.componentInstance.mode = mode;
    modalRef.componentInstance.alarmId = alarmId;
    modalRef.componentInstance.alarmIsLevelValidable = true;
  }

  reLoadList(status: string = STATUS.TO_VALID.VALUE): void {
    this.getValidableAlarms(status);
  }

  applyFilter(filterValue: string): void {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.validableAlarmsList.filter = filterValue;
  }

  validateAlarm(alarmId: number): Subscription {
    this.showSpinner = true;
    return this.alarmService.patchValidateAlarm(alarmId).subscribe(
      () => {
        this.toastr.success(this.translate.instant('ALARM_VALIDATED'), this.translate.instant('SUCCESS'));
        this.showSpinner = false;
        this.getValidableAlarms();
      },
      () => {
        this.showSpinner = false;
      }
    );
  }

  inValidateAlarm(alarmId: number): Subscription {
    this.showSpinner = true;
    return this.alarmService.patchInvalidateAlarm(alarmId).subscribe(
      () => {
        this.toastr.success(this.translate.instant('ALARM_INVALIDED'), this.translate.instant('SUCCESS'));
        this.showSpinner = false;
        this.getValidableAlarms();
      },
      () => {
        this.showSpinner = false;
      }
    );
  }

  private getValidableAlarms(status: string = STATUS.TO_VALID.VALUE): Subscription {
    this.matTableColumnAdapter(status);
    this.showSpinner = true;
    return this.alarmService.getValidableAlarms(status)
      .pipe(map((validableAlarms: ValidableAlarm[]) => {
          return this.alarmService.validableAlarmsFormatter(validableAlarms);
        })
      )
      .subscribe(
        (validableAlarms: ValidableAlarm[]) => {
          this.initValidableAlarmsList(validableAlarms);
          this.showSpinner = false;
        },
        () => {
          this.showSpinner = false;
        });
  }

  private matTableColumnAdapter(status: string): void {
    this.displayedColumns = (status === STATUS.TO_VALID.VALUE)
      ? this.defaultDisplayedColumn.concat(['actions'])
      : this.defaultDisplayedColumn;
  }

  private initValidableAlarmsList(validableAlarms: ValidableAlarm[]): void {
    this.validableAlarmsList = new MatTableDataSource(validableAlarms);
    this.validableAlarmsList.sort = this.sort;
    this.validableAlarmsList.paginator = this.paginator;
    this.validableAlarmsList.paginator.firstPage();
    this.validableAlarmsList.filter = '';
  }

}
